export default __webpack_public_path__ + "static/media/product4.ad126603.webp";